/* eslint-disable react/no-multi-comp, react/prop-types */

import { connect } from 'react-redux';
import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import { SHORT_HUMAN_DATE_FORMAT } from 'constants';
import Person from 'services/data/person';


export function convertCheckboxObjectToArray(filterObject) {
  // Map the checked filters (which look like { active: 'true' }) to their keys
  // Ignore unchecked filters (which look like { active: false } or { active: 'false' })
  const keys = _(filterObject).map((value, key) => {
    if (value === 'true' || value === true) return key;
    return undefined;
  }).compact().value();

  if (!keys.length) return;
  return { in: keys };
}


export function getDateRangeFilter(dates) {
  const minDate = _.get(dates, 'min');
  const maxDate = _.get(dates, 'max');

  if (!minDate && !maxDate) return;

  return {
    '<=': maxDate ? moment(maxDate).endOf('day').toDate() : undefined,
    '>=': minDate ? moment(minDate).startOf('day').toDate() : undefined
  };
}

export function didQueryUpdate(nextProps, prevProps) {
  const newQuery = nextProps.query;
  const oldQuery = prevProps.query;
  const queryUpdated = newQuery !== oldQuery;
  const settingDefaults = newQuery.setDefaultQuery;

  return queryUpdated && !settingDefaults;
}

export function getInWithNullFilter(filter) {
  if (!filter || filter.length === 0) return;

  return {
    or: {
      in: filter,
      is: null
    }
  };
}

export function getRecurrenceFilter(filter) {
  if (!filter || filter.length === 0 || filter.length === 2) return;
  const value = filter[0];

  if (value === 'Recurring tasks') {
    return { '@>': '{ "enabled": true }' };
  }

  return { not: { '@>': '{ "enabled": true }' } };
}

export function RenderArrayFilter({ values, label, options }) {
  if (options && options.length === values.length) return null;

  return <RenderFilter label={label} value={_.join(values, ', ')} />;
}

export function RenderMappedArrayFilter({ values, label, options }) {
  if (options && options.length === values.length) return null;

  const map = _.keyBy(options, 'value');
  const mappedValues = _.map(values, id => _.get(map, `${id}.label`));

  return <RenderFilter label={label} value={_.join(mappedValues, ', ')} />;
}

export function RenderDateFilter({ values, label }) {
  if (!values.min && !values.max) return null;
  if (!values.min) return <RenderFilter label={`${label} Before`} value={moment(values.max).format(SHORT_HUMAN_DATE_FORMAT)} />;
  if (!values.max) return <RenderFilter label={`${label} After`} value={moment(values.min).format(SHORT_HUMAN_DATE_FORMAT)} />;

  return <RenderFilter label={`${label} Between`} value={`${moment(values.min).format(SHORT_HUMAN_DATE_FORMAT)} - ${moment(values.max).format(SHORT_HUMAN_DATE_FORMAT)}`} />;
}

function RenderUserFilterComponent({ values, label, users }) {
  if (!users || !users.length) return null;

  const map = _.keyBy(users, 'id');
  const initials = _.map(values, id => _.get(map, `${id}.poPrefix`));

  return <RenderFilter label={label} value={_.compact(_.join(initials, ', '))} />;
}

export const RenderUserFilter = connect((state) => ({ users: state.pageData.selectUsers }))(RenderUserFilterComponent);

function RenderSingleUserFilterComponent({ values, label, users }) {
  if (!users || !users.length) return null;

  const map = _.keyBy(users, 'id');
  const name = Person.fullName(map[values]);

  return <RenderFilter label={label} value={name} />;
}

export const RenderSingleUserFilter = connect((state) => ({ users: state.pageData.selectUsers }))(RenderSingleUserFilterComponent);

function RenderCompanyFilterComponent({ values, label, companies }) {
  if (!companies || !companies.length) return null;

  const map = _.keyBy(companies, 'id');
  const nicknames = _.map(_.concat([], values), id => _.get(map, `${id}.nickname`));

  return <RenderFilter label={label} value={_.join(nicknames, ', ')} />;
}

export const RenderCompanyFilter = connect((state) => ({ companies: state.pageData.selectCompanies }))(RenderCompanyFilterComponent);

function RenderTeamFilterComponent({ value, label, teams }) {
  if (!teams || !teams.length) return null;

  const map = _.keyBy(teams, 'id');

  return <RenderFilter label={label} value={map[value].name} />;
}

export const RenderTeamFilter = connect((state) => ({ teams: state.pageData.teams }))(RenderTeamFilterComponent);

export function RenderFilter({ label, value }) {
  return (
    <div className="render-filter">
      <div className="render-filter-label">{label}:</div>
      <div className="render-filter-value">{value}</div>
    </div>
  );
}
